'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _Composite = require('../Composite');

var _Label = require('../Label');

var _Label2 = _interopRequireDefault(_Label);

var _Dropdown = require('../Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _InputAreaWithLabelComposite = require('../Composite/InputAreaWithLabelComposite/InputAreaWithLabelComposite');

var _InputAreaWithLabelComposite2 = _interopRequireDefault(_InputAreaWithLabelComposite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DropdownComposite = function DropdownComposite(_ref) {
  var props = _objectWithoutProperties(_ref, []),
      children = _ref.children;

  return _react2.default.createElement(
    _InputAreaWithLabelComposite2.default,
    props,
    children
  );
};

DropdownComposite.propTypes = {
  children: (0, _Composite.children)((0, _Composite.optional)(_Label2.default), (0, _Composite.once)(_Dropdown2.default)),
  required: _propTypes.bool,
  appendToParent: _propTypes.bool,
  info: _propTypes.node,
  tooltip: _propTypes.node
};

DropdownComposite.displayName = 'DropdownComposite';

exports.default = DropdownComposite;